const Style = {

  table: 'w-full border-separate -mb-6 tabular-nums',
  search: 'mb-4 md:mb-0',
  loading: 'relative py-8',
  badge: 'ml-0',
  empty: 'py-3',
  thead: 'hidden md:table-header-group',
  th_actions: 'text-right',

  th: `text-left outline-0 uppercase text-[11px] tracking-[0.04em] font-medium text-sg-mut
    p-5 border-b border-solid border-sg-line first:pl-0 last:pr-0`,
  sort: `relative cursor-pointer after:absolute after:right-0 after:top-1/2 after:mt-1
    after:w-3 after:h-3 after:opacity-50 after:-translate-y-1/2 after:bg-contain`,

  asc: `after:bg-[url('components/table/icons/ico-sort-asc.svg')]`,
  desc: `after:bg-[url('components/table/icons/ico-sort-dsc.svg')]`,

  cell: `float-left w-full p-0 mb-2 text-sg-slate first:pl-0 last:pr-0 last:pb-5 last:border-b last:border-solid
    last:border-sg-line md:float-none md:w-auto md:mb-0 md:p-5 md:border-b md:border-solid md:border-sg-line`,

  actions: `text-left float-left clear-left mb-4 whitespace-nowrap
  md:float-none md:clear-none md:text-right md:mb-0 border-b border-sg-line border-solid`,

  actionButton: 'inline-block whitespace-nowrap -top-1 mr-3 bg-transparent last:mr-0',

}

export default Style;